import { Link } from "react-router"
import "./style.scss"

export default function Footer () {

    return (
        <footer className="footer">
          <div className="footer-wrapper">
            <ul>
              <li><Link to={"/legal/impressum"}>Impressum</Link></li>
              <li><Link to={"/legal/datenschutz"}>Datenschutz</Link></li>
              <li><Link to={"/legal/nutzungsbedingungen"}>Nutzungsbedingungen</Link></li>
              <li><Link to={"/teilnahmebedingungen-treueprogramm"}>Teilnahmebedingungen Pall Mall Club</Link></li>
              <li><a id="ot-sdk-btn" className="ot-sdk-show-settings" style={{cursor: "pointer"}}>Individuelle Cookie-Einstellungen</a></li>
            </ul>
            <p className="copyrights">© 2025 BAT - British American Tobacco.<br/>Alle Rechte vorbehalten.</p>
          </div>
        </footer>
    )
}